// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"e0b4f186","107":"fd7944bb","453":"cde45ae5","819":"42f10d50"}[chunkId] + ".chunk.js";
};